module.exports = __webpack_public_path__ + "img/4F439F_A28BE5_8570D6_7765C9-256px.e5be981a.png";